module.exports = __webpack_public_path__ + "static/media/6.8af8ce2a.jpg";